import {push} from 'react-router-redux';

export const errorRedirect = () => (dispatch, getState) => {
    const {authorization: {isGuest}, router: {location: {pathname}} } = getState();
    const hasUrl = pathname.includes('welcome-to-equify-auctions');

    if (isGuest && hasUrl) {
        dispatch(push('/404'));
    };
}